import React, { useState } from 'react'

export default function AccordionSection({
  title,
  subtitle = null,
  defaultOpen = true,
  children,
  className = '',
}) {
  const [open, setOpen] = useState(defaultOpen)

  return (
    <div className={['mobile-style-accordion', 'assistant-accordion-section', className].join(' ').trim()}>
      <button
        type="button"
        className="mobile-style-accordion__summary"
        aria-expanded={open}
        onClick={() => setOpen((current) => !current)}
      >
        <div className="mobile-style-accordion__title-row">
          <span className="accordion-section__title">{title}</span>
        </div>
        {subtitle ? (
          <div className="accordion-section__subtitle">{subtitle}</div>
        ) : null}
      </button>
      {open ? <div className="mobile-style-accordion__content">{children}</div> : null}
    </div>
  )
}
